import React from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Layout from '../components/Layout';

const AboutPage = () => {
  const faqItems = [
    {
      question: "Why did we build Kast?",
      answer: "We became tired of constantly saving posts, videos and articles and almost never coming back to them. Even with the smart algorithms behind our favourite apps, the best content often gets lost in the noise. We built Kast because we believe the best recommendations come from the people whose taste you trust. It’s a place for you to see what your smartest friends are saving online, and store your own finds too."
    },
    {
      question: "Who is Kast for?",
      answer: "Anyone! Especially those who value interesting and thoughtful content. Whether you want a constant stream curated finds from the people you know, or simply want a space to saving things for later - Kast is for you."
    },   
    {
      question: "What’s coming next for Kast?",
      answer: "Right now, the lightweight Kast web app makes it easy to save links and explore what your friends are finding. But this is just the start. By speaking regularly with our early users, we’ll be adding big new features to Kast which fit how you already discover, consume and share the best things you come across online."
    }
  ];

  return (
    <Layout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box
          sx={{
            border: '1px solid black',
            borderRadius: 4,
            p: 2,
            backgroundColor: '#fefaf6',
            boxShadow: '0px 2px 5px rgba(0,0,0,0.05)'
          }}
        >
          {faqItems.map((item, index) => (
            <Accordion
              key={index}
              disableGutters
              sx={{
                boxShadow: 'none',
                backgroundColor:'#fefaf5',
                '&:before': { display: 'none' },
                borderBottom: index !== faqItems.length - 1 ? '1px solid #d3cfc9' : 'none',
                borderRadius: 0
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#837e76' }} />}
                sx={{
                  color: '#837e76',
                  fontWeight: 500,
                  fontSize: '1rem'
                }}
              >
                {item.question}
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ color: '#837e76', fontSize: '0.95rem', lineHeight: 1.6 }}>
                  {item.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography
            variant="body1"
            sx={{ color: '#837e76', mb: 1 }}
          >
            How’s Kast feeling so far? Anything you’d like to see next?
          </Typography>
          <TextField
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            placeholder=""
            sx={{
              backgroundColor:'#fefaf5',              
              '& fieldset': {
                border: '1px solid black',
                borderRadius: 4,
              }
            }}
          />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mt: 2,
              gap:5
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#f57c00',
                borderRadius: '24px',
                px: 5,
                py: 1.2,
                boxShadow: 'none',
                textTransform: 'none',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#ef6c00'
                }
              }}
            >
              Share
            </Button>

            <FormControlLabel
              control={<Checkbox />}
              label="Keep Anonymous?"
              sx={{
                color: '#837e76',
                fontSize: '0.9rem',
                '.MuiFormControlLabel-label': {
                  fontSize: '0.875rem'
                }
              }}
            />
          </Box>
        </Box>
      </Container>
    </Layout>
  );
};

export default AboutPage;
